import { LoaderType, NextgenImage, useTranslation } from '@nextgen-web-framework/all';
import SubHeader from '../../../common/SubHeader/SubHeader';
import styles from './NoDownlines.module.scss';
import NoDownlinesProps from './types/propTypes';

const NoDownlines = ({ headingText }: NoDownlinesProps) => {
  const t = useTranslation();

  return (
    <>
      <SubHeader headingText={headingText} />
      <div className={styles['search-suggestion-container']} data-testid="no-result-found">
        <NextgenImage
          alt={t('subscription.subscriptionmanagement.tabs.downline.noUserFound')}
          src="/icons/EmptyResult.svg"
          data-testid="no-result-image-testid"
          objectFit="contain"
          width={168}
          height={238}
          className={styles['no-downlines-image']}
          loaderType={LoaderType.WEBFONTS}
          isRelativeURL={true}
        />

        <div className={styles['suggestion-content']}>
          <div className={styles['content-title']}>
            {t('subscription.subscriptionmanagement.tabs.downline.noUserFound')}
          </div>
          <div className={styles['content-subtitle']}>
            {t('subscription.subscriptionmanagement.tabs.downline.noUserFound.suggestionText')}
          </div>
        </div>
      </div>
    </>
  );
};

export default NoDownlines;
